import React from "react";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { PreviewUrlUnified } from "@/features/previews/shared/components/PreviewUrlUnified/PreviewUrlUnified";
import { useUrlData, UrlPreviewProps } from "./hooks/useUrlData";
import "./UrlTemplate.scss";

export function UrlTemplate(props: UrlPreviewProps) {
  const { qrUrlLink, translations, isInitPreview, preview } = useUrlData(props);

  return (
    <div className="url-template">
      <PhoneLayout
        page={props.type}
        dataQA={`preview-${props.type}-container`}
        isInitPreview={isInitPreview}
        hasIncludeBrowser
      >
        <PreviewUrlUnified
          qrUrlLink={qrUrlLink}
          translations={translations}
          preview={preview}
        />
      </PhoneLayout>
    </div>
  );
}
